import React from 'react';
import { useMove } from '@react-aria/interactions';

export const useDraggable = (ref: React.MutableRefObject<HTMLDivElement | null>): any => {
    const [position, setPosition] = React.useState({
        x: 0,
        y: 0,
    });

    const { moveProps } = useMove({
        onMove(event) {
            const rect = ref.current?.getBoundingClientRect();

            // Prevent dragging out of bounds
            if (
                rect &&
                (rect.left + event.deltaX < 0 ||
                    rect.right + event.deltaX > window.innerWidth ||
                    rect.top + event.deltaY < 0 ||
                    rect.bottom + event.deltaY > window.innerHeight)
            ) {
                return;
            }

            setPosition(({ x, y }) => {
                x += event.deltaX;
                y += event.deltaY;
                return { x, y };
            });
        },
    });

    return {
        position,
        handleProps: moveProps,
    };
};
